import React, { useCallback, useMemo } from 'react';
// import { Modal, Button, Form, Tabs, Tab, Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import styles from './FilePreview.module.css'
// import { formatDateFromDB } from '../../../util/functions'
import FileViewer from 'react-file-viewer';
import noImage from '../../../assets/no-image.png'
import * as settings from '../../../settings'

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

const FilePreview = React.memo(({ file, fileCategory, fileUrl }) => {
    const [t] = useTranslation('common')
    const { fileName, _id, createdAt, fileType } = file

    const staticFileUrl = useMemo(() => {
        return fileUrl
    }, [_id])

    const onError = (e) => {
        console.log('Error in file-viewer', e);
    };

    const getFileViewer = useCallback(() => {
        return <FileViewer
            fileType={fileType}
            filePath={staticFileUrl}
            onError={onError}
        />
    }, [staticFileUrl, fileType])

    let previewElement
    let filePreviewContainerAdditionalClass = ``

    switch (fileCategory) {
        case 'image':
            // filePreviewContainerAdditionalClass = process.env.NODE_ENV === 'development' ? '' : `${styles['no-transform']}`
            filePreviewContainerAdditionalClass = `${styles['no-transform']}`
            previewElement = <img className={styles['image-file']} src={fileUrl} alt={fileName} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
            break;
        case 'document':
            filePreviewContainerAdditionalClass = process.env.NODE_ENV === 'development' ? '' : `${styles['no-transform']}`
            // filePreviewContainerAdditionalClass = `${styles['no-transform']}`
            previewElement = getFileViewer()
            break
        case 'audio':
            filePreviewContainerAdditionalClass = `${styles['no-transform']}`
            previewElement = getFileViewer()
            break
        case 'video':
            // filePreviewContainerAdditionalClass = process.env.NODE_ENV === 'development' ? '' : `${styles['no-transform']}`
            filePreviewContainerAdditionalClass = `${styles['no-transform']}`
            previewElement = getFileViewer()
            break
        case undefined:
            filePreviewContainerAdditionalClass = process.env.NODE_ENV === 'development' ? '' : `${styles['no-transform']}`
            if (fileType === 'jpeg') previewElement = <img className={styles['image-file']} src={fileUrl} alt={fileName} onError={(event) => { event.target.onerror = null; event.target.src = noImage }} />
            else previewElement = getFileViewer()
            break;
        default:
            previewElement = getFileViewer()
    }

    return (
        <section className={`file-preview-section ${styles['file-preview-section']}`}>
            <div className={`${styles['file-preview-sticky']} ${filePreviewContainerAdditionalClass}`}>
                {previewElement}
            </div>
        </section>
    )
    // return (
    //     <Modal show={true} onHide={onHide} dialogClassName={`${styles['preview-modal']}`} size="lg" centered aria-labelledby="contained-modal-title-vcenter" className='rtl-modal' >
    //         <Modal.Header>
    //             <Modal.Title className={styles['modal-title']}>
    //                 <div className={styles['file-header-container']}>
    //                     <h3 className={styles['file-name']}>{fileName}</h3>
    //                     <time className={styles['file-date']}>{formatDateFromDB(createdAt)}</time>
    //                 </div>
    //             </Modal.Title>
    //         </Modal.Header>
    //         <Modal.Body className={`preview-modal-body ${styles['preview-modal-body']}`}>

    //             <FileViewer
    //                 fileType={fileType}
    //                 filePath={fileUrl}
    //                 onError={onError}
    //             />

    //         </Modal.Body>
    //         <Modal.Footer>
    //             <Button variant="secondary" onClick={onHide}>{t('Exit')}</Button>
    //             {/* <Button type='submit' form="contactForm" variant="primary" className='btn-success'>{t('save')}</Button> */}
    //         </Modal.Footer>
    //     </Modal>
    // )
})

export default FilePreview